import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Tag } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { blogPosts } from '../data/mock';
import StarburstDecor from '../components/ui/StarburstDecor';

const BlogDetailPage = () => {
  const { id } = useParams();
  const post = blogPosts.find((p) => p.id === parseInt(id));

  if (!post) {
    return (
      <Layout>
        <div className="container-main py-20 text-center">
          <h1 className="text-2xl font-bold text-navy">Blog post not found</h1>
          <Link to="/blogs" className="text-lime hover:underline mt-4 inline-block">
            Back to Blogs
          </Link>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      {/* Hero */}
      <section className="bg-white py-16 relative">
        <div className="container-main">
          <Link
            to="/blogs"
            className="inline-flex items-center gap-2 text-navy hover:text-lime transition-colors mb-6"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Blogs
          </Link>
          
          <div className="max-w-3xl">
            <div className="flex items-center gap-4 mb-4">
              <span className="text-xs font-medium px-3 py-1 bg-lime text-navy rounded-full">
                {post.category}
              </span>
              <span className="text-sm text-gray-500 flex items-center gap-1">
                <Calendar className="w-4 h-4" />
                {post.date}
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-navy">
              {post.title}
            </h1>
          </div>
          
          <div className="absolute top-8 right-8 hidden lg:block">
            <StarburstDecor size={100} />
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="bg-white py-8">
        <div className="container-main">
          <div className="rounded-2xl overflow-hidden aspect-video max-w-4xl mx-auto">
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="bg-white py-12">
        <div className="container-main">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <p className="text-gray-600 leading-relaxed text-lg">
              {post.excerpt}
            </p>
            <p className="text-gray-600 leading-relaxed mt-6">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">Key Takeaways</h2>
            <p className="text-gray-600 leading-relaxed">
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mt-4">
              <li>Understanding user needs through comprehensive research</li>
              <li>Creating intuitive interfaces that users love</li>
              <li>Iterating based on feedback and data</li>
              <li>Staying ahead of industry trends</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-6">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BlogDetailPage;
